import { InjectionToken } from '@angular/core';
import {
  contextApps,
  contextMotionDesign,
  FilterGroup,
} from '@nx-icilalune/data/icilalune/types';
import { Breakpoint } from '@icilalune/utils/responsive';

export const PROJECT_LIST_CONTEXT = new InjectionToken<
  typeof contextApps | typeof contextMotionDesign
>('PROJECT_LIST_CONTEXT');

export const PROJECT_LIST_FILTERS = new InjectionToken<FilterGroup[]>(
  'PROJECT_LIST_FILTERS'
);

export const CLIENT_LIST_FILTERS = new InjectionToken<FilterGroup[]>(
  'CLIENT_LIST_FILTERS'
);

export const CLIENT_ID = new InjectionToken<string | undefined>('CLIENT_ID');

export const LIST_BREAKPOINT = new InjectionToken<Breakpoint>(
  'LIST_BREAKPOINT'
);
